import { TopHeader, CTNavbar, CTSearchView } from '../components';
import { use } from 'react';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';
import { SharedReports, Blog, AccountSettings } from "pageComponents";
import { ViewReports } from '../components';
import ProviderMenu from './login/providerMenu';
import UserLandingPage from './userLandingPage';
import { PatientConversation } from 'pageComponents';

const ProviderLandingPage = (props) => {
  const location = useLocation();
  const [isProviderReports, setIsProviderReports] = useState(false);

  const [isFromReports, setIsFromReports] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  const [activeSharedTab, setActiveSharedTab] = useState('Request Access');
  const [navItems, setNavItems] = useState([]);
  const [showViewReports, setShowViewReports] = useState(false);
  const MenuData = useSelector((state) => state.apiService.menuItem);
  const token = useSelector((state) => state.apiService.token);
  const userData = useSelector((state) => state.apiService.login);
  const [showActiveMenuItems, setShowActiveMenuItems] = useState([]);
  const [activeMenuItem, setActiveMenuItem] = useState
    ({
      showSharedReports: false,
      showBlog: false,
      showPatientConversation: false,
    })

  const navigate = useNavigate();
  const [selectedPatientName, setSelectedPatientName] = useState('');

  useEffect(() => {
    if (MenuData && Array.isArray(MenuData)) {
      const updatedNavItems = MenuData.map(item => ({
        menu_id: item.menu_id,
        title: item.title || "Untitled",
        url: item.url || "#",
        parent_id: item.parent_id || null,
        sort_order: item.sort_order || 0,
        type: item.type || ""
      }));
      setNavItems(updatedNavItems);
    }
  }, [MenuData])

  // Handle navigation from View Shared Reports button
  useEffect(() => {
    if (location.state?.showPatientSummary && location.state?.isFromDetails && props.activeMenuItem?.showDashBoard) {
      // Trigger patient summary view like TbListDetails click
      const patientUserId = localStorage.getItem('patientUserId');
      const patientUserName = localStorage.getItem('patientUserName');

      if (patientUserId && patientUserName) {
        setIsProviderReports(true);
        setSelectedPatientName(patientUserName);
        setIsFromDetails(true);
      }
    }
  }, [location.state, props.activeMenuItem?.showDashBoard]);

  // Reset isProviderReports when navigating to main tabs (not in reports view)
  useEffect(() => {
    // console.log('useEffect triggered with props.activeMenuItem:', props.activeMenuItem);
    if (props.activeMenuItem?.showBlog ||
      // props.activeMenuItem?.showSharedReports ||
      props.activeMenuItem?.showPatientConversation) {
      setIsProviderReports(false);
      setIsFromReports(false);
      setIsFromDetails(false);
    }
    if (props.activeMenuItem?.showSharedReports) {
      // console.log('Setting activeSharedTab to Request Access in useEffect');
      setIsProviderReports(false);
      props.activeMenuItem.showSharedReports = true
      // Don't call props.onViewReportsClick as it might override our tab setting
      // const activeTab = {
      //   menu_id: 4
      // }
      // props.onViewReportsClick(activeTab)
      props.activeMenuItem.showDashBoard = false
      props.activeMenuItem.showReports = false
      setIsFromReports(false);
      setIsFromDetails(false);
      setActiveSharedTab('Request Access');
    }
  }, [props.activeMenuItem?.showBlog, props.activeMenuItem?.showSharedReports, props.activeMenuItem?.showPatientConversation]);

  const resetActiveTab = () => {
    setActiveTab('');
  }

  const handleReportClick = () => {
    setShowViewReports(true);
    // Don't call setActiveMenuItems with false as it might reset the tab
  }

  const setActiveMenuItems = (event) => {
    // If event is false, don't process it
    if (!event) return;

    // console.log('setActiveMenuItems called with:', event);
    // console.log('userData:', userData);
    // console.log('userData?.user_type_name:', userData?.user_type_name);

    setIsProviderReports(false);
    const newActiveMenuItem = {
      showSharedReports: event.menu_id === 4,
      showBlog: event.menu_id === 5,
      showPatientConversation: event.menu_id === 25,
    };
    // Set appropriate default tab based on user type
    const isProvider = userData?.user_type_name === 'Provider';
    const tabToSet = isProvider ? 'Request Access' : 'With You';
    setActiveSharedTab(tabToSet);
    setActiveMenuItem(newActiveMenuItem);
  }

  const [isFromDetails, setIsFromDetails] = useState(false);

  const handlePatientSummaryClick = (userId, name) => {
    setIsProviderReports(true);
    setSelectedPatientName(name);
    setIsFromDetails(true);
    props.activeMenuItem.showSharedReports = false
    props.activeMenuItem.showDashBoard = true
  }

  const handleReportIconClick = (userId, name) => {
    props.activeMenuItem.showReports = true
    props.activeMenuItem.showSharedReports = false
    props.activeMenuItem.showDashBoard = false
    props.activeMenuItem.showBlog = false
    props.activeMenuItem.showPatientConversation = false
    setIsProviderReports(true);
    setSelectedPatientName(name);
    setActiveSharedTab(name);
    setIsFromDetails(false);
    setIsFromReports(true);

  }

  const handleBackToRequestAccess = () => {
    setIsProviderReports(false);
    props.activeMenuItem.showSharedReports = true
    // Don't call props.onViewReportsClick as it might override our tab setting
    // const activeTab = {
    //   menu_id: 4
    // }
    // props.onViewReportsClick(activeTab)
    props.activeMenuItem.showDashBoard = false
    props.activeMenuItem.showReports = false
    setIsFromReports(false);
    setIsFromDetails(false);
    setActiveSharedTab('Request Access');

  };

  return (
    <>

      {/* <div className="fixed-top" style={{ verticalAlign: "center", flex: 1, alignContent: 'center', alignItems: 'center' }}>
                <div className="shadow-lg">
                    <TopHeader />
                </div>
                <div className="py-2 p-2 ms-3 me-3">
                    <CTNavbar
                        navItems={navItems}
                      activeTab={activeTab}
                      setDashboard={setActiveMenuItems}
                        setActiveTab={setActiveTab}
                    />
                </div>
            </div>
            <div style={{
                height: "80px" 
      }}></div>   */}
      <div className='ms-3 me-3 mt-5 mb-10' >
        <div className='mb-10'>
          {isProviderReports &&
            <UserLandingPage activeMenuItem={props.activeMenuItem} activeTab={props.activeTab} onViewReportsClick={props.onViewReportsClick}
              isFromProviderDashboard={false}
              userID={localStorage.getItem('patientUserId')}
              patientName={selectedPatientName}
              onBack={handleBackToRequestAccess}
              isFromDetails={isFromDetails}
              isFromReports={isFromReports}
            />}
        </div>

        {!isProviderReports &&
          <>
            {props.activeMenuItem.showSharedReports && (
              <>
                <SharedReports
                  handlePatientSummaryClick={handlePatientSummaryClick}
                  activeSharedTab={activeSharedTab}
                  setActiveTab={setActiveTab}
                  handleReportIconClick={handleReportIconClick}
                  selectedFamilyMember={props.selectedFamilyMember}
                />
              </>
            )}
            {props.activeMenuItem.showBlog && <Blog />}
            {props.activeMenuItem.showProfile && <AccountSettings />}
            {props.activeMenuItem.showPatientConversation && <PatientConversation />}
            {/* {isProviderReports && activeTab === 'reports' && <ViewReports />} */}
          </>
        }
      </div>

      {/* <div className='fixed-bottom' style={{ zIndex: 1000 }} >
        {isProviderReports && isFromDetails && <ProviderMenu />}
      </div> */}
    </>
  )
}

export default ProviderLandingPage;